import api from './api';
import { ColorCollectionUnit, CreateColorCollectionUnitData, UpdateColorCollectionUnitData } from '../types/colorCollectionUnit';

export const colorCollectionUnitService = {
  // Get all units for a color collection
  getByColorCollection: async (
    workspaceId: string,
    colorCollectionId: string,
    page?: number,
    limit?: number,
    search?: string
  ) => {
    const params: any = {};
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;
    if (search) params.search = search;

    const response = await api.get(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/units`,
      { params }
    );
    return response.data;
  },

  // Add a unit to a color collection
  create: async (
    workspaceId: string,
    colorCollectionId: string,
    data: CreateColorCollectionUnitData
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/units`,
      data
    );
    return response.data;
  },

  // Add multiple units to a color collection
  createMultiple: async (
    workspaceId: string,
    colorCollectionId: string,
    units: CreateColorCollectionUnitData[]
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/units/bulk`,
      { units }
    );
    return response.data;
  },

  // Update a unit in a color collection
  update: async (
    workspaceId: string,
    colorCollectionId: string,
    unitId: string,
    data: UpdateColorCollectionUnitData
  ) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/units/${unitId}`,
      data
    );
    return response.data;
  },

  // Update multiple units in a color collection
  updateMultiple: async (
    workspaceId: string,
    colorCollectionId: string,
    units: UpdateColorCollectionUnitData[]
  ) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/units/bulk`,
      { units }
    );
    return response.data;
  },

  // Remove a unit from a color collection
  delete: async (
    workspaceId: string,
    colorCollectionId: string,
    unitId: string
  ) => {
    const response = await api.delete(
      `/workspaces/${workspaceId}/pkg-color-collections/${colorCollectionId}/units/${unitId}`
    );
    return response.data;
  }
};
